import { z } from "zod";
import { apiGet } from "../lib/api";

export const ModelOptionSchema = z.object({
  key: z.string(),
  label: z.string(),
  provider: z.string(),
  supports_tools: z.boolean(),
  supports_parallel_tools: z.boolean(),
  requires_secret: z.string().nullable(),
  secret_ready: z.boolean(),
});
export type ModelOption = z.infer<typeof ModelOptionSchema>;

export const ModelListSchema = z.array(ModelOptionSchema);

export function listModels(): Promise<ModelOption[]> {
  return apiGet("/api/models", ModelListSchema);
}

/** A model is selectable only once any secret it needs is actually set —
 *  otherwise picking it produces a call the worker refuses, with the real
 *  reason buried in worker logs. */
export function modelIsSelectable(m: ModelOption): boolean {
  return m.requires_secret === null || m.secret_ready;
}
